import { SignatureFormat } from '../signature-types';
import { decodeDataUrl, encodeDataUrl } from './data-url';
export const encodePoints = (points)=>encodeDataUrl({
        data: JSON.stringify(points),
        mimeType: SignatureFormat.POINTS
    });
export const decodePoints = (dataUrl)=>{
    const decodedDataUrl = decodeDataUrl(dataUrl);
    if (decodedDataUrl?.mimeType === SignatureFormat.POINTS) {
        try {
            const points = JSON.parse(decodedDataUrl.data);
            return points;
        } catch (e) {
            return null;
        }
    }
    return null;
};

//# sourceMappingURL=points.js.map